import React, { useState } from 'react';


const DateSelector = ({ selectedDate, onDateChange }) => {
  const [date, setDate] = useState(selectedDate || new Date().toISOString().substr(0, 10));

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setDate(newDate);
    onDateChange(newDate);
  };

  return (
    <div>
      <input
        type="date"
        value={date}
        onChange={handleDateChange}
        style={{ padding: '5px', fontSize: '16px' }}
      />
    </div>
  );
};

export default DateSelector;